module.exports = __webpack_public_path__ + "img/globe.5186997f.png";